import { useCallback, useEffect, useRef, useState } from 'react';

/** 429（同時実行ジョブ上限）を受けたときに出す案内。 */
export const GENERATION_BUSY_MESSAGE = '混み合っています。数秒後に再度お試しください。';

export const isTooManyJobsError = (error: unknown): boolean =>
  (error as { response?: { status?: number } } | null)?.response?.status === 429;

/**
 * 429 を受けたあと、しばらく生成ボタンを押せなくする。
 * 押せるままだと、同時実行枠が空くまで 429 を返し続けるリクエストを連打されるため。
 * 判定はクリック直後でも最新になるよう ref（isActive）で行い、表示は state（coolingDown）で行う。
 */
export function useGenerationCooldown(durationMs = 10_000) {
  const untilRef = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [coolingDown, setCoolingDown] = useState(false);

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    []
  );

  const start = useCallback(() => {
    untilRef.current = Date.now() + durationMs;
    setCoolingDown(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      untilRef.current = 0;
      setCoolingDown(false);
    }, durationMs);
  }, [durationMs]);

  const isActive = useCallback(() => Date.now() < untilRef.current, []);

  return { coolingDown, start, isActive };
}
